import React from 'react';
import {Dialog} from 'components/core';
import UserInfo from './UserInfo';
import {UsersCtx} from 'components/dataProviders/users';

export default function UserInfoDialog({userID, open, onClose})
{
    const ctx = React.useContext(UsersCtx);

    if(!ctx.data.indexed[userID]) return null;
    
    return <Dialog open={open} onClose={onClose}>
        <UserInfo user={ctx.data.indexed[userID]} />
    </Dialog>
}